import type { EventAlertBannerProps } from '@/lib/types/events.types';
import { EventDetailsContent } from '@/content/EventDetailsContent';

export function EventAlertBanner({ type }: EventAlertBannerProps) {
  const content =
    type === 'deadline'
      ? EventDetailsContent.alertDeadlinePassed
      : EventDetailsContent.alertCapacityReached;

  return (
    <div
      data-testid={`event-alert-${type}`}
      className="bg-sky-300 text-slate-600 rounded-lg p-4 mt-4"
    >
      <p className="font-bold text-body">{content.title}</p>
      <p className="text-body">{content.message}</p>
    </div>
  );
}

